// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_ai-4";
export var collapsed = "_ai-1";
export var headerBar = "_ai-0";
export var leftHeaderContent = "_ai-3";
export var subjectContainer = "_ai-2";